import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import {
  GlobeEuropeAfricaIcon,
  ArrowUpOnSquareIcon,
  BuildingLibraryIcon,
  CursorArrowRaysIcon,
  BookmarkSquareIcon,
  ShieldCheckIcon,
  Squares2X2Icon,
  BanknotesIcon,
  BellAlertIcon,
  LifebuoyIcon,
  ChartBarIcon,
  Bars3Icon,
  PhoneIcon,
  XMarkIcon,
  CubeIcon,
  FireIcon,
  PlayIcon,
} from "@heroicons/react/24/outline";

import { useDetectClickOutside } from "react-detect-click-outside";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { triggerContact } from "../../redux/appReducer";
import { useDispatch, useSelector } from "react-redux";
import { HEADER } from "../../intl/header";
import { Link } from "gatsby";

import Section from "../Section/Section";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Header = () => {
  const { lang, COMPANY_NAME, REGISTER_URL, LOGIN_URL, LOGO, mode, origin } =
    useSelector((state) => state.appReducer);

  const copy = HEADER[lang];

  const dispatch = useDispatch();

  const ref = useDetectClickOutside({ onTriggered: () => handleClick(false) });
  const [openMobile, setOpenMobile] = useState(false);
  const queryParams =
    typeof sessionStorage !== "undefined" && sessionStorage.getItem("umt");

  useEffect(() => {
    document.getElementById("body").classList.remove("overflow-y-hidden");
  }, []);

  const products = {
    product: [
      {
        name: copy.product.valuations.name,
        description: copy.product.valuations.description,
        href: "/valuations",
        icon: ShieldCheckIcon,
      },
      {
        name: copy.product.metasearch.name,
        description: copy.product.metasearch.description,
        href: "/metasearch",
        icon: BellAlertIcon,
      },
      {
        name: copy.product.insights.name,
        description: copy.product.insights.description,
        href: "/insights",
        icon: ChartBarIcon,
      },
      {
        name: copy.product.website.name,
        description: copy.product.website.description,
        href: "/website",
        icon: Squares2X2Icon,
      },
      {
        name: copy.product.digitalValuer.name,
        description: copy.product.digitalValuer.description,
        href: "/digital-valuer",
        icon: CursorArrowRaysIcon,
      },
    ],
    solutions: [
      {
        name: copy.solutions.portfolio.name,
        description: copy.solutions.portfolio.description,
        href: "/portfolio",
        icon: BuildingLibraryIcon,
        color: "red",
      },
      {
        name: copy.solutions.risk.name,
        description: copy.solutions.risk.description,
        href: "/risk",
        icon: BanknotesIcon,
        color: "red",
      },
      {
        name: copy.solutions.opportunities.name,
        description: copy.solutions.opportunities.description,
        href: "/opportunity",
        icon: ArrowUpOnSquareIcon,
        color: "red",
      },
      {
        name: copy.solutions.avms.name,
        description: copy.solutions.avms.description,
        href: "/avms",
        icon: CubeIcon,
        color: "red",
      },
      {
        name: copy.solutions.observatory.name,
        description: copy.solutions.observatory.description,
        href: "/observatory",
        icon: GlobeEuropeAfricaIcon,
        color: "red",
      },
    ],
  };

  const product_categories = [
    {
      id: "product",
      name: copy.product.title,
      icon: PlayIcon,
    },
    {
      id: "solutions",
      name: copy.solutions.title,
      icon: PhoneIcon,
    },
  ];

  const resources = [
    {
      name: copy.resources.about.name,
      description: copy.resources.about.description.replace(
        "COMPANY_NAME",
        COMPANY_NAME
      ),
      href: "/about",
      icon: LifebuoyIcon,
    },
    {
      name: copy.resources.careers.name,
      description: copy.resources.careers.description.replace(
        "COMPANY_NAME",
        COMPANY_NAME
      ),
      href: "/careers",
      icon: BookmarkSquareIcon,
    },
    {
      name: copy.resources.cases.name,
      description: copy.resources.cases.description,
      href: "/use-cases",
      icon: FireIcon,
    },
  ];

  const recentPosts = [
    { id: 1, name: copy.recentPosts.post1, href: "/price-index" },
  ];

  const handleContactClick = () => {
    dispatch(triggerContact());
    handleClick(false);
  };

  const handleClick = (open) => {
    if (open)
      document.getElementById("body").classList.add("overflow-y-hidden");
    else document.getElementById("body").classList.remove("overflow-y-hidden");
    setOpenMobile(open);
  };

  return (
    <header
      className="bg-neutral-900 text-white"
      //className="sticky top-0 shadow-sm z-30 backdrop-blur-3xl bg-background/80 dark:bg-neutral-900/80"
    >
      <Popover className="relative">
        <Section>
          <div className="flex items-center justify-between py-4 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <Link to="/">
                <span className="sr-only">{COMPANY_NAME}</span>
                <img
                  //  className="h-8 w-auto md:h-10 block"
                  className="max-h-[30px] sm:max-h-[35px] md:max-h-[35px] block"
                  src={LOGO.dark}
                  height="100%"
                  alt="logo"
                />
              </Link>
            </div>
            {/* MOBILE BTN */}
            <div className="-my-2 -mr-2 md:hidden">
              <Popover.Button
                className="inline-flex items-center justify-center p-2 text-gray-400 hover:bg-gray-100 hover:text-neutral-500 focus:outline-none"
                onClick={() => handleClick(true)}
              >
                <span className="sr-only">Open menu</span>
                <Bars3Icon className="h-8 w-8" aria-hidden="true" />
              </Popover.Button>
            </div>
            <Popover.Group as="nav" className="hidden space-x-10 md:flex ">
              <Popover className="relative">
                {({ open }) => (
                  <>
                    <Popover.Button
                      className={classNames(
                        open ? "text-neutral-300" : "text-white",
                        "group inline-flex items-center font-medium hover:text-neutral-300 focus:outline-none  "
                      )}
                    >
                      <span>{copy.products}</span>
                      <ChevronDownIcon
                        className={classNames(
                          open
                            ? "text-neutral-300 rotate-180 transform"
                            : "text-white",
                          "ml-2 h-5 w-5 group-hover:text-neutral-300"
                        )}
                        aria-hidden="true"
                      />
                    </Popover.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute z-10 -ml-4 mt-3 w-screen max-w-2xl transform px-2 sm:px-0 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 ">
                        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                          <div className="space-y-6 bg-white py-5 sm:space-y-0 sm:space-x-10 sm:px-8 grid grid-cols-2 dark:bg-neutral-800">
                            {product_categories.map((category) => (
                              <div
                                key={category.name}
                                className="flow-root col-span-1"
                              >
                                <span className="text-neutral-400">
                                  {category.name}
                                </span>
                                <div className="relative grid gap-6 bg-white py-6 sm:gap-8 dark:bg-neutral-800">
                                  {products[category.id].map((item) => (
                                    <Popover.Button
                                      as={Link}
                                      className="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-neutral-900"
                                      key={item.name}
                                      to={item.href}
                                    >
                                      {category.id === "solutions" ? (
                                        <div className="bg-yellow-500/10 p-2.5 rounded-lg">
                                          <item.icon
                                            className={classNames(
                                              "h-6 w-6 flex-shrink-0",
                                              "text-[#F2B447] "
                                            )}
                                            aria-hidden="true"
                                          />
                                        </div>
                                      ) : (
                                        <div className="bg-[#009de0]/10 p-2.5 rounded-lg">
                                          <item.icon
                                            className={classNames(
                                              "h-6 w-6 flex-shrink-0",
                                              "text-[#009de0]"
                                            )}
                                            aria-hidden="true"
                                          />
                                        </div>
                                      )}
                                      <div className="ml-4">
                                        <p className="text-base font-medium text-neutral-900 dark:text-white">
                                          {item.name}
                                        </p>
                                        <p className="mt-1 text-sm text-neutral-500">
                                          {item.description}
                                        </p>
                                      </div>
                                    </Popover.Button>
                                  ))}
                                </div>
                                {/*   </a> */}
                              </div>
                            ))}
                          </div>

                          <div
                            className="grid gap-6 bg-gray-50 px-5 py-6 sm:gap-8 sm:p-8 cursor-pointer text-neutral-900 dark:bg-neutral-800 dark:text-white"
                            onClick={handleContactClick}
                          >
                            {copy.contact}
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>

              <Link
                to="/pricing"
                className="text-base font-medium text-white hover:text-neutral-300 dark:text-white"
              >
                {copy.pricing}
              </Link>

              <Popover className="relative">
                {({ open }) => (
                  <>
                    <Popover.Button
                      className={classNames(
                        open ? "text-neutral-300" : "text-white",
                        "group inline-flex items-center font-medium hover:text-neutral-300 focus:outline-none  "
                      )}
                    >
                      <span>{copy.company}</span>
                      <ChevronDownIcon
                        className={classNames(
                          open
                            ? "text-neutral-300 rotate-180 transform"
                            : "text-white",
                          "ml-2 h-5 w-5 group-hover:text-neutral-300"
                        )}
                        aria-hidden="true"
                      />
                    </Popover.Button>

                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0 translate-y-1"
                      enterTo="opacity-100 translate-y-0"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100 translate-y-0"
                      leaveTo="opacity-0 translate-y-1"
                    >
                      <Popover.Panel className="absolute left-1/2 z-10 mt-3 w-screen max-w-md -translate-x-1/2 transform px-2 sm:px-0">
                        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                          <div className="relative grid gap-6 bg-white dark:bg-neutral-800 px-5 py-6 sm:gap-8 sm:p-8">
                            {resources.map((item) => (
                              <Popover.Button
                                as={Link}
                                className="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-neutral-900"
                                key={item.name}
                                to={item.href}
                              >
                                <item.icon
                                  className="h-6 w-6 flex-shrink-0 text-[#009de0]"
                                  aria-hidden="true"
                                />
                                <div className="ml-4">
                                  <p className="text-base font-medium text-neutral-900 dark:text-white">
                                    {item.name}
                                  </p>
                                  <p className="mt-1 text-sm text-neutral-500">
                                    {item.description}
                                  </p>
                                </div>
                              </Popover.Button>
                            ))}
                          </div>
                          <div className="bg-gray-50 px-5 py-5 sm:px-8 sm:py-8 dark:bg-neutral-800">
                            <div>
                              <h3 className="text-base font-medium text-neutral-500">
                                {copy.recentNews}
                              </h3>
                              <ul role="list" className="mt-4 space-y-4">
                                {recentPosts.map((post) => (
                                  <li
                                    key={post.id}
                                    className="truncate text-base"
                                  >
                                    <Popover.Button
                                      as={Link}
                                      to={post.href}
                                      className="font-medium text-neutral-900 dark:text-white hover:text-gray-700"
                                    >
                                      {post.name}
                                    </Popover.Button>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </>
                )}
              </Popover>

              {origin === "pt" && (
                <Link
                  className="hidden lg:flex text-base font-medium text-white hover:text-neutral-300 dark:text-white"
                  to="/price-index"
                >
                  {copy.priceIndex}
                </Link>
              )}
            </Popover.Group>
            <div className="hidden items-center justify-end md:flex md:flex-1 lg:w-0">
              <Link
                className="whitespace-nowrap text-base font-medium text-white hover:text-neutral-300 dark:text-white"
                to={LOGIN_URL}
              >
                {copy.signIn}
              </Link>
              <Link
                className="ml-8 inline-flex items-center justify-center whitespace-nowrap rounded-xl border border-transparent bg-neutral-800 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-white hover:text-neutral-900"
                to={REGISTER_URL + queryParams}
              >
                {copy.signUp}
              </Link>
            </div>
          </div>
        </Section>
        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
          show={openMobile}
          ref={ref}
        >
          <Popover.Panel className="absolute inset-x-0 z-10 top-0 origin-top-right transform p-2 transition md:hidden">
            <div className="divide-y-2 divide-gray-50 rounded-lg bg-white max-h-[98vh] shadow-lg overflow-y-scroll dark:bg-neutral-800">
              <div className="px-5 pt-5 pb-6">
                <div className="flex items-center justify-between">
                  <div>
                    <Link to="/">
                      <span className="sr-only">{COMPANY_NAME}</span>
                      <img
                        //   className="h-8 w-auto md:h-10 block "
                        className="max-h-[30px] sm:max-h-[35px] md:max-h-[35px] block focus:outline-none"
                        src={LOGO[mode]}
                        height="100%"
                        alt="logo"
                      />
                    </Link>
                  </div>
                  <div className="-mr-2">
                    <Popover.Button
                      onClick={() => handleClick(false)}
                      className="inline-flex items-center justify-center rounded-xl p-2 text-gray-400 hover:bg-gray-100 hover:text-neutral-500 focus:outline-none  "
                    >
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon
                        className="h-7 w-7 stroke-2"
                        aria-hidden="true"
                      />
                    </Popover.Button>
                  </div>
                </div>
                <div className="mt-6">
                  <nav className="grid gap-y-8">
                    <Popover className="relative">
                      {({ open }) => (
                        <>
                          <Popover.Button
                            className={classNames(
                              "text-neutral-900 dark:text-white",
                              "group inline-flex items-center rounded-xl  text-base font-medium hover:text-neutral-900 dark:text-white focus:outline-none  "
                            )}
                          >
                            <span>{copy.products}</span>
                            <ChevronDownIcon
                              className={classNames(
                                open
                                  ? "text-gray-600 rotate-180 transform"
                                  : "text-gray-400",
                                "ml-2 h-5 w-5 group-hover:text-neutral-500"
                              )}
                              aria-hidden="true"
                            />
                          </Popover.Button>

                          <Popover.Panel>
                            <div className="relative grid gap-6 pl-5 pt-6">
                              {[...products.product].map((item) => (
                                <Link
                                  className="-m-3 flex items-start rounded-lg py-4 hover:bg-gray-50 dark:hover:bg-neutral-900"
                                  onClick={() => handleClick(false)}
                                  key={item.name}
                                  to={item.href}
                                >
                                  <item.icon
                                    className="h-6 w-6 flex-shrink-0 text-[#009de0]"
                                    aria-hidden="true"
                                  />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-neutral-900 dark:text-white">
                                      {item.name}
                                    </p>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          </Popover.Panel>
                        </>
                      )}
                    </Popover>

                    <Popover className="relative">
                      {({ open }) => (
                        <>
                          <Popover.Button
                            className={classNames(
                              "text-neutral-900 dark:text-white",
                              "group inline-flex items-center rounded-xl  text-base font-medium hover:text-neutral-900 dark:text-white focus:outline-none  "
                            )}
                          >
                            <span>{copy.services}</span>
                            <ChevronDownIcon
                              className={classNames(
                                open
                                  ? "text-gray-600 rotate-180 transform"
                                  : "text-gray-400",
                                "ml-2 h-5 w-5 group-hover:text-neutral-500"
                              )}
                              aria-hidden="true"
                            />
                          </Popover.Button>

                          <Popover.Panel>
                            <div className="relative grid gap-6 pl-5 pt-6">
                              {[...products.solutions].map((item) => (
                                <Link
                                  className="-m-3 flex items-start rounded-lg py-4 hover:bg-gray-50"
                                  onClick={() => handleClick(false)}
                                  key={item.name}
                                  to={item.href}
                                >
                                  <item.icon
                                    className={classNames(
                                      "h-6 w-6 flex-shrink-0",
                                      "text-[#F2B447]"
                                    )}
                                    aria-hidden="true"
                                  />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-neutral-900 dark:text-white">
                                      {item.name}
                                    </p>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          </Popover.Panel>
                        </>
                      )}
                    </Popover>

                    <Link
                      className="text-base font-medium text-neutral-900 dark:text-white"
                      onClick={() => handleClick(false)}
                      to="/pricing"
                    >
                      {copy.pricing}
                    </Link>

                    {/*     {resources.map((item) => (
                      <Link
                        className="text-base font-medium text-neutral-900 dark:text-white"
                        onClick={() => handleClick(false)}
                        key={item.name}
                        to={item.href}
                      >
                        {item.name}
                      </Link>
                    ))}
 */}

                    {/*    {recentPosts.map((post) => (
                      <Link
                        to={post.href}
                        className="text-base font-medium text-neutral-900 dark:text-white"
                      >
                        {post.name}
                      </Link>
                    ))} */}

                    <Popover className="relative">
                      {({ open }) => (
                        <>
                          <Popover.Button
                            className={classNames(
                              "text-neutral-900 dark:text-white",
                              "group inline-flex items-center rounded-xl  text-base font-medium hover:text-neutral-900 dark:text-white focus:outline-none  "
                            )}
                          >
                            <span>{copy.company}</span>
                            <ChevronDownIcon
                              className={classNames(
                                open
                                  ? "text-gray-600 rotate-180 transform"
                                  : "text-gray-400",
                                "ml-2 h-5 w-5 group-hover:text-neutral-500"
                              )}
                              aria-hidden="true"
                            />
                          </Popover.Button>

                          <Popover.Panel>
                            <div className="relative grid gap-6 pl-5 pt-6">
                              {resources.map((item) => (
                                <Link
                                  className="-m-3 flex items-start rounded-lg py-4 hover:bg-gray-50"
                                  onClick={() => handleClick(false)}
                                  key={item.name}
                                  to={item.href}
                                >
                                  <item.icon
                                    className={classNames(
                                      "h-6 w-6 flex-shrink-0",
                                      "text-[#009de0]"
                                    )}
                                    aria-hidden="true"
                                  />
                                  <div className="ml-4">
                                    <p className="text-base font-medium text-neutral-900 dark:text-white">
                                      {item.name}
                                    </p>
                                  </div>
                                </Link>
                              ))}
                              {recentPosts.map((post) => (
                                <div
                                  key={post.id}
                                  className="truncate text-base"
                                >
                                  <Link
                                    to={post.href}
                                    className="font-medium text-neutral-900 dark:text-white hover:text-gray-700"
                                  >
                                    {post.name}
                                  </Link>
                                </div>
                              ))}
                            </div>
                          </Popover.Panel>
                        </>
                      )}
                    </Popover>

                    {origin === "pt" && (
                      <Link
                        className="text-base font-medium text-neutral-900 dark:text-white"
                        to="/price-index"
                      >
                        {copy.priceIndex}
                      </Link>
                    )}

                    <div
                      className="text-base font-medium text-neutral-900 dark:text-white"
                      onClick={handleContactClick}
                    >
                      {copy.contact}
                    </div>
                  </nav>
                </div>
              </div>
              <div className="space-y-6 py-6 px-5">
                <Link
                  className="flex w-full items-center justify-center rounded-xl  border  border-transparent bg-neutral-800 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-neutral-900"
                  to={REGISTER_URL + queryParams}
                >
                  {copy.signUp}
                </Link>
                <p className="m-6 text-center text-base font-medium text-neutral-500">
                  {copy.existing}{" "}
                  <Link
                    to={LOGIN_URL}
                    className="text-[#009de0] hover:text-blue-500"
                  >
                    {copy.signIn}
                  </Link>
                </p>
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>
    </header>
  );
};

export default Header;
